import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, UrlSegment} from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Observable } from 'rxjs';

interface BreadcrumbRouteData {
  breadcrumb?: string | ((params: any) => string);
}

declare module '@angular/router' {
  interface DataBr {
    breadcrumb?: string | ((params: any) => string);
  }
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private _breadcrumbs$ = new BehaviorSubject<MenuItem[]>([]);

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const breadcrumbs = this.buildBreadcrumbs();
        this._breadcrumbs$.next(breadcrumbs);
      });
  }

  get breadcrumbs$(): Observable<MenuItem[]> {
    return this._breadcrumbs$.asObservable();
  }

  private buildBreadcrumbs(): MenuItem[] {
    const menuItems: MenuItem[] = [];
    let currentRoute = this.activatedRoute.root;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const routeData = currentRoute.snapshot.data;
      
      let labelStr = "";
      if (routeData['breadcrumb']) {
             labelStr = typeof routeData['breadcrumb'] === 'function'
                    ? routeData['breadcrumb'](currentRoute.snapshot.params)
                    : routeData['breadcrumb'];
      }

      if (routeData['parentBreadcrumb']) {
        menuItems.push({
          label: routeData['parentBreadcrumb'],
          routerLink: this.getParentRoute(currentRoute),
        });
      } 

      menuItems.push({
        label: labelStr,
        routerLink: this.getFullRoutePath(currentRoute),
      });
      
    }

    return menuItems;
  }

  private getParentRoute(route: ActivatedRoute): string[] {
    let currentRoute = this.activatedRoute.root;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    
    const parentBreadcrumb = currentRoute.snapshot.data['parentBreadcrumb'];
    
    // Mapeamento explícito de breadcrumb pai para rota
    const parentRouteMap: { [key: string]: string[] } = {
      'Ínicio': ['/obrigacoes-acessorias'],
      'Consulta Omissão': ['/obrigacoes-acessorias']
    };
    
      return parentRouteMap[parentBreadcrumb];    
  
  }

  private getFullRoutePath(route: ActivatedRoute): string[] {
    return ['/', ...route.pathFromRoot
      .map((r: ActivatedRoute) => r.snapshot.url.map((segment: UrlSegment) => segment.path))
      .reduce((acc, val) => acc.concat(val), [])]; // Substitui o flatMap
  }

}